export const PLUGIN_NAME = 'web-vitals-browser';
export const WEB_VITALS_EVENT_NAME = '[Amplitude] Web Vitals';
